module.exports = __webpack_public_path__ + "img/wordpress.5854066e.png";